import { Component, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Vendor, VendorService } from '../vendor.service'
import { Router } from '@angular/router'
import { BuilderService } from 'src/app/builder-services/builder.service'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  displayedColumns: string[] = ['id', 'name', 'orders', 'total', 'creationDate']
  dataSource = new MatTableDataSource<Vendor>([])

  // Totals across all projects
  totalOrders = 0
  totalRevenue = 0

  startDate: Date | null = null
  endDate: Date | null = null
  searchValue: string = '' // holds input text

  constructor(public vendor: VendorService ,private builderService:BuilderService,private router: Router) {
    // search filter by Project ID
    this.dataSource.filterPredicate = (data: Vendor, filter: string) => {
      const filterLower = filter.trim().toLowerCase()
      const idStr = data.id?.toString().toLowerCase() || ''
      return idStr.includes(filterLower)
    }
  }

  ngOnInit() {
    this.dataSource.data = this.vendor.vendorsList
    this.builderService.showUpdateProgress = true
    this.vendor.calculateProjectRevenues(this.dataSource.data, this.startDate, this.endDate).subscribe((result) => {
      this.dataSource.data = [...result.vendors]
      this.totalOrders = result.totalOrders
      this.totalRevenue = result.totalRevenue

      this.builderService.showUpdateProgress = false

    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
    this.dataSource.sortingDataAccessor = (data: Vendor, sortHeaderId: string) => {
      if (sortHeaderId === 'id') {
        return data.id || ''
      }
      return (data as any)[sortHeaderId] as string | number
    }
    this.dataSource.sort.active = 'id'
    this.dataSource.sort.direction = 'desc'
    this.dataSource.sort.sortChange.emit()
  }

  // Called when clicking the button
  onSearch() {
    const filterValue = this.searchValue.trim().toLowerCase()
    this.dataSource.filter = filterValue

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage()
    }
  }

  // Filter by date range
  applyDateRange(): void {
    if (this.startDate) {
      this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())
    }
    if (this.endDate) {
      this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), 23, 59, 59)
    }
    this.builderService.showUpdateProgress = true
    this.vendor.calculateProjectRevenues(this.vendor.vendorsList, this.startDate, this.endDate).subscribe((result) => {
      // Show only vendors that actually have orders in the range
      this.dataSource.data = result.vendors.filter((v) => Number(v.orders) > 0)

      this.totalOrders = result.totalOrders
      this.totalRevenue = result.totalRevenue
      this.builderService.showUpdateProgress = false

    })
  }

  clearDateRange(): void {
    this.startDate = null
    this.endDate = null
    this.builderService.showUpdateProgress = true

    // reload with all vendors, regardless of orders
    this.vendor.calculateProjectRevenues(this.vendor.vendorsList).subscribe((result) => {
      this.dataSource.data = [...result.vendors] // show all vendors again
      this.totalOrders = result.totalOrders
      this.totalRevenue = result.totalRevenue
      this.builderService.showUpdateProgress = false

    })
  }
  /**
   *  navigate To Vendor 
   * @param projectId
   */
  navigateToVendor(projectId: string) {
  localStorage.setItem('selectedProject', projectId);
  window.location.replace('/orders'); // or assign(...)
  }
}
